var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[ 'tooltip-holder d-flex', { light: _vm.light } ]},[_vm._t("default"),_c('div',{class:[
			'tooltip d-flex align-items-center',
			`tooltip-${_vm.position}`
		],style:({ width: _vm.widthString })},[_c('div',{staticClass:"tooltip__content"},[_vm._t("content")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }